<template>
  <div class="modules-settings-tenants-list">
    <div class="nav-section">
      <a
        @click="navToTenancyUserTab()"
        class="nav-back"
      >{{ $t('action.backToTenancyUserTab') }}</a>
    </div>

    <label class="title">{{ $t('settings.user.tenant.all') }}</label>
    <div style="display: inline; vertical-align: middle;"><span>{{ $t('total') }}: {{ orderedItems.length }} / {{ recordCounts }}</span></div>

    <div class="tender-table">
      <template>
        <table>
          <thead>
            <th
              v-for="(header, index) in itemHeaders"
              :class="header.class"
              :key="index"
            >
              {{ $t(header.name) }}
            </th>
          </thead>
          <tbody>
            <tr>
              <td class="tenant-id">
                <input
                  type="text"
                  class="setting-users-filter-search"
                  v-model="itemHeaders[0].filter"
                >
              </td>
              <td class="tenant-name">
                <input
                  type="text"
                  class="setting-users-filter-search"
                  v-model="itemHeaders[1].filter"
                >
              </td>
              <td class="settings-filter align-center tenant-special">
                <HKLSelect
                  :value="itemHeaders[2].filter"
                  class="align-center"
                  settings-filter-row
                  :options="ynHklOptions"
                  :showSearch="false"
                  placeholder=""
                  @change="val => { itemHeaders[2].filter = val }"
                />
              </td>
            </tr>
            <tr
              v-for="item in orderedItems"
              :key="item.id"
            >
              <td class="tenant-id">
                <a @click="navToDetail(item.id)">{{ item.id }}</a>
              </td>
              <td class="tenant-name">
                <a @click="navToDetail(item.id)">{{ item.name }}</a>
              </td>
              <td class="tenant-special">
                <a>{{ item.special | customYNLabel }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'

import HKLSelect from '@/controls/Select/HKLSelect.vue'

import * as accountsRequest from '@/api/accounts/request'
import EventBus from '@/utils/eventBus'
import navigation from '@/utils/navigation'

function getDefaultData () {
  const ynOptions = {
    ALL: 'All',
    YES: 'YES',
    NO: 'NO',
  }

  return {
    ynOptions,
    recordCounts: '',
    items: [],
    orderbyAttr: 'name',
    reverse: 0,
    itemHeaders: [
      {
        code: 'id',
        name: 'tenancy.companyId',
        class: 'tenant-id',
        filter: '',
      },
      {
        code: 'name',
        name: 'tenancy.companyName',
        class: 'tenant-name',
        filter: '',
      },
      {
        code: 'merged',
        name: 'tenancy.merged',
        class: 'tenant-special',
        filter: ynOptions.ALL,
      },
    ],
  }
}

export default {
  name: 'AllTenants',
  data: getDefaultData,
  components: {
    HKLSelect,
  },
  methods: {
    sortBy (attr) {
      if (this.orderbyAttr === attr) {
        this.reverse = !this.reverse
      }
      this.orderbyAttr = attr
    },
    parseItems (items = []) {
      return items.reduce((partial, item) => {
        if (!item || !item.id || !item.name) return
        item.special = item.specialHandled ? this.ynOptions.YES : this.ynOptions.NO
        partial.push(item)
        return partial
      }, [])
    },

    async initPage () {
      const [items, count] = await accountsRequest.getAllTenantAccounts()
      this.items = this.parseItems(items)
      this.recordCounts = count
    },
    navToDetail (id) {
      if (id) {
        navigation.toPage(
          'tenant-detail',
          {
            id,
          },
        )
      }
    },
    navToTenancyUserTab () {
      navigation.toPage('setting-users')
      EventBus.emit('active-user-tab', 'tenant')
    },
  },
  computed: {
    ynHklOptions () {
      return Object.values(this.ynOptions).map((value) => ({
        name: this.$options.filters.customYNLabel(value),
        value,
      }))
    },
    orderedItems () {
      const filteredResult =
        this.items.filter(item => {
          try {
            if (item.id.toString().indexOf(this.itemHeaders[0].filter) !== -1 &&
              item.name.toString().toLowerCase().indexOf(this.itemHeaders[1].filter.toString().toLowerCase()) !== -1) {
              return item
            }
          } catch (err) { }
          return null
        }).filter(item => {
          try {
            const mergedFilter = this.itemHeaders[2].filter
            if (this.ynOptions.ALL === mergedFilter || mergedFilter === item.special) {
              return item
            }
            return null
          } catch (err) { }
          return null
        })
      const result = lodash.orderBy(filteredResult, this.orderbyAttr)
      return this.reverse ? result.reverse() : result
    },
  },
  async mounted () {
    await this.initPage()
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings/style';

.modules-settings-tenants-list {
  padding: 0 24px;

  .title {
    font-weight: bold;
    margin-bottom: 10px;
  }

  input {
    width: 100%;
  }

  .tenant-id {
    width: 200px;
    padding: 2px 15px;
  }

  .tenant-name {
    padding: 2px 15px;
    text-align: left;
  }

  .tenant-special {
    width: 140px;
    padding: 2px 15px;
    margin: auto;
  }

  thead th {
    .tenant-id, .tenant-name {
      padding-left: 23px;
    }
  }
}
</style>
